export default __webpack_public_path__ + "static/media/IMG_9898.67979c73.jpg";